export interface ApplicationStoreStateType {
  applicationList: Array<any>;
  isAppSubmitLoading: boolean;
  batchList: {
    [id: string]: any;
  };
}

export const ApplicationStoreState: ApplicationStoreStateType = {
  applicationList: [],
  isAppSubmitLoading: false,
  batchList: {},
};
